import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { PROCESS, FEATURES, COMPANY } from "../data/mock";

export default function HowItWorks() {
  return (
    <main>
      <section className="bg-[var(--brand-hero)]">
        <div className="mx-auto max-w-4xl px-5 py-16 text-center lg:py-20 lg:px-8">
          <span className="text-sm font-bold uppercase tracking-wider text-teal-brand">How it Works</span>
          <h1 className="mt-3 text-4xl font-extrabold text-navy-brand sm:text-5xl">
            Selling your inventory, made simple
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-slate-500">
            From your first inventory submission to same-week payment, we make selling your inventory
            simple. Here is exactly what to expect at every step.
          </p>
        </div>
      </section>

      {/* Steps timeline */}
      <div className="mx-auto max-w-4xl px-5 py-16 lg:px-8">
        <div className="relative">
          <div className="absolute left-8 top-0 hidden h-full w-0.5 bg-slate-200 sm:block" />
          <div className="space-y-8">
            {PROCESS.map((p) => {
              const Icon = p.icon;
              return (
                <div key={p.n} className="relative flex gap-6">
                  <div className="relative z-10 flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-navy-brand text-white shadow-lg">
                    <Icon size={26} />
                  </div>
                  <div className="flex-1 rounded-2xl border border-slate-100 bg-white p-6 shadow-sm">
                    <div className="flex items-center gap-3">
                      <span className="text-sm font-extrabold text-teal-brand">Step {p.n}</span>
                      <h3 className="text-lg font-bold text-navy-brand">{p.title}</h3>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-slate-500">{p.text}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Why choose */}
      <section className="bg-slate-50">
        <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="text-3xl font-extrabold text-navy-brand sm:text-4xl">Why sellers choose us</h2>
          </div>
          <div className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {FEATURES.map((f) => {
              const Icon = f.icon;
              return (
                <div key={f.title} className="rounded-2xl bg-white p-7 shadow-sm">
                  <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-teal-brand/10 text-teal-brand">
                    <Icon size={26} />
                  </div>
                  <h3 className="mb-2 text-[17px] font-bold text-navy-brand">{f.title}</h3>
                  <p className="text-sm leading-relaxed text-slate-500">{f.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="rounded-3xl bg-navy-brand px-6 py-12 text-center text-white lg:px-12">
          <h2 className="text-2xl font-extrabold sm:text-3xl">Ready to get started?</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-slate-300">
            Submit your inventory today and get a free, no-obligation consultation from our team.
          </p>
          <Link
            to="/contact"
            className="mt-7 inline-flex items-center gap-2 rounded-full bg-teal-brand px-7 py-3.5 text-sm font-semibold text-white transition-transform hover:scale-105"
          >
            Submit Your Inventory <ArrowRight size={17} />
          </Link>
        </div>
      </div>
    </main>
  );
}
